import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '../../services/apis.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(
    private router: Router,
    private apiService: ApisService,
  ) {}

  ngOnInit(): void {
    const userSession = this.apiService.getFromSession();
    if (userSession !== null) {
      this.apiService.changeUserData(userSession);
      this.apiService.setHeaders(userSession.access_token);
      this.router.navigate(['']);
    }
  }

  login(): void {
    window.location.href = `${ environment.authUrl }/${ environment.tenantId }/login`;
  }
}
